<template>
  <div class="task-wrap">
    <van-tabs
      v-model="taskStatus"
      :lazy-render="false"
      color="#333333"
      sticky
      line-width="32"
      line-height="2"
      :ellipsis="false"
      :before-change="beforeChangeTabs"
      @change="handleTabClick"
    >
      <van-tab :title="`未完成(${taskTotal.unfinishedCount})`" name="2">
      </van-tab>
      <van-tab :title="`逾期(${taskTotal.expireCount})`" name="4"> </van-tab>
      <van-tab :title="`已完成(${taskTotal.finishCount})`" name="3"> </van-tab>
      <van-tab :title="`全部(${taskTotal.totalCount})`" name=""> </van-tab>
      <template slot="nav-right">
        <div class="tab-btn" @click="onOpenFilter">
          <img
            v-if="!showOverlay"
            class="icon-filter"
            src="@/assets/img/task/icon_filter.png"
          />
          <img
            v-else
            class="icon-filter"
            src="@/assets/img/task/icon_filter1.png"
          />
        </div>
      </template>
      <van-overlay :show="showOverlay" @click="showOverlay = false" />
    </van-tabs>
    <div v-if="showOverlay" class="task-type">
      <div class="popup-title">任务类型</div>
      <div class="param-list">
        <div
          class="p-item"
          :class="taskType === '' ? 'act' : ''"
          @click="checkType('')"
        >
          全部
        </div>
        <div
          class="p-item"
          :class="taskType === 3 ? 'act' : ''"
          @click="checkType(3)"
        >
          素材转发
        </div>
        <div
          class="p-item"
          :class="taskType === 4 ? 'act' : ''"
          @click="checkType(4)"
        >
          添加好友
        </div>
        <div
          class="p-item"
          :class="taskType === 5 ? 'act' : ''"
          @click="checkType(5)"
        >
          打卡核验
        </div>
        <div
          class="p-item"
          :class="taskType === 2 ? 'act' : ''"
          @click="checkType(2)"
        >
          周期任务
        </div>
        <div
          class="p-item"
          :class="taskType === 1 ? 'act' : ''"
          @click="checkType(1)"
        >
          单次任务
        </div>
      </div>
    </div>
    <van-list
      v-model="loading"
      class="task-list"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="item in list" :key="item.id" class="task-cell">
        <div class="head">
          <div style="width: 80%">{{ item.taskName }}</div>
          <div class="h-txt">{{ item.taskTypeDesc }}</div>
        </div>
        <div class="cont">
          <div class="c-txt">
            {{ item.taskDetail }}
          </div>
          <div
            v-if="item.taskType === 3 && item.additionalInfo"
            class="source-material"
          >
            <div
              v-for="x in item.materialList"
              :key="x.id"
              class="material-item"
            >
              <img
                v-if="x.type === 1"
                class="file-img"
                :src="x.cosPath + '&imageMogr2/crop/32x32'"
                alt=""
              />
              <img
                v-if="x.type === 2"
                class="file-img"
                :src="x.videoCoverUrl + '&imageMogr2/crop/32x32'"
                alt=""
              />
              <img
                v-if="x.type === 3"
                class="file-img"
                :src="x.imgUrl + '&imageMogr2/crop/32x32'"
                alt=""
              />
              <template>
                <img
                  v-if="
                    x.type === 4 &&
                      (x.attachment.ext === 'png' || x.attachment.ext === 'jpg')
                  "
                  class="file-img"
                  src="@/assets/img/material/icon_img.png"
                  alt=""
                />
                <img
                  v-else-if="x.type === 4 && x.attachment.ext === 'mp4'"
                  class="file-img"
                  src="@/assets/img/material/icon_video.png"
                  alt=""
                />
                <img
                  v-else-if="
                    x.type === 4 &&
                      (x.attachment.ext === 'xlsx' ||
                        x.attachment.ext === 'xls')
                  "
                  class="file-img"
                  src="@/assets/img/material/icon_excel.png"
                  alt=""
                />
                <img
                  v-else-if="
                    x.type === 4 &&
                      (x.attachment.ext === 'docx' ||
                        x.attachment.ext === 'doc')
                  "
                  class="file-img"
                  src="@/assets/img/material/icon_word.png"
                  alt=""
                />
                <img
                  v-else-if="x.type === 4 && x.attachment.ext === 'zip'"
                  class="file-img"
                  src="@/assets/img/material/icon_zip.png"
                  alt=""
                />
                <img
                  v-else-if="
                    x.type === 4 &&
                      (x.attachment.ext === 'ppt' ||
                        x.attachment.ext === 'pptx')
                  "
                  class="file-img"
                  src="@/assets/img/material/icon_ppt.png"
                  alt=""
                />
                <img
                  v-else-if="x.type === 4 && x.attachment.ext === 'pdf'"
                  class="file-img"
                  src="@/assets/img/material/icon_pdf.png"
                  alt=""
                />
                <img
                  v-else-if="
                    x.type === 4 &&
                      (x.attachment.ext === 'mp3' ||
                        x.attachment.ext === 'amr' ||
                        x.attachment.ext === 'wav')
                  "
                  class="file-img"
                  src="@/assets/img/material/icon_mp3.png"
                  alt=""
                />
                <img
                  v-else-if="x.type === 4 && x.attachment.ext === 'psd'"
                  class="file-img"
                  src="@/assets/img/material/icon_psd.png"
                  alt=""
                />
              </template>
              <div>{{ x.title }}</div>
            </div>
          </div>
          <div
            v-if="
              (item.taskType === 1 ||
                item.taskType === 2 ||
                item.taskType === 5 ||
                item.taskType === 6) &&
                item.taskLinkUrl
            "
            class="attachment"
            @click="goAttachment(item)"
          >
            {{ item.taskLinkTitle }}
          </div>
        </div>
        <div class="footer">
          <div v-if="item.taskStatus === 2">剩余时间：{{ item.otherTime }}</div>
          <div v-if="item.taskStatus === 4">已逾期：{{ item.otherTime }}</div>
          <div v-if="item.taskStatus === 3 || item.taskStatus === 5">
            完成时间：{{ formatTime(item.finishTime) }}
          </div>
          <div
            v-if="
              item.taskType === 3 &&
                item.taskStatus !== 3 &&
                item.taskStatus !== 5
            "
            class="footer-btn"
            @click="forwardFn(item)"
          >
            转发
          </div>
          <div
            v-if="
              item.taskType === 3 &&
                (item.taskStatus === 3 || item.taskStatus === 5)
            "
            class="footer-btn"
            @click="forwardFn(item)"
          >
            继续转发
          </div>
          <div
            v-if="
              (item.taskType === 1 ||
                item.taskType === 2 ||
                (item.taskType === 6 && item.isFeedback === 0)) &&
                (item.taskStatus === 2 || item.taskStatus === 4)
            "
            class="footer-btn"
            @click="handleTask(item)"
          >
            完成
          </div>
          <div
            v-if="item.taskType === 4 && item.taskStatus !== 3"
            class="footer-btn"
            @click="goDetails(item, 1)"
          >
            添加好友
          </div>
          <div
            v-if="
              item.taskType === 5 &&
                item.taskStatus !== 3 &&
                item.taskStatus !== 5
            "
            class="footer-btn"
            @click="goDetails(item, 1)"
          >
            提交核验信息
          </div>
          <div
            v-if="
              (item.taskType === 4 ||
                item.taskType === 5 ||
                (item.taskType === 6 && item.isFeedback === 1)) &&
                (item.taskStatus === 3 || item.taskStatus === 5)
            "
            class="footer-btn"
            @click="goDetails(item, 2)"
          >
            详情
          </div>
          <div
            v-if="
              item.taskType === 6 &&
                item.isFeedback === 1 &&
                item.taskStatus !== 3 &&
                item.taskStatus !== 5
            "
            class="footer-btn"
            @click="goDetails(item, 1)"
          >
            提交反馈
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import {
  taskListApi,
  finishTaskApi,
  statisticsApi,
  getshareInfoListApi,
} from "@/api/modules/task";
import { uploadMediaApi, addForwardRecordApi } from "@/api/modules/material";
import { Toast } from "vant";
import dayjs from "dayjs";
import wxSDK from "@/scripts/wxsdk";
import { browseEvent, pageClickEvent } from "@/utils/utils";

export default {
  name: "Task",
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      // 任务数量统计
      taskTotal: {
        unfinishedCount: 0,
        expireCount: 0,
        finishCount: 0,
        totalCount: 0,
      },
      showOverlay: false, // 遮层falg
      list: [],
      baseList: [],
      loading: false,
      finished: false,
      pageIndex: 1,
      pageSize: 10,
      taskStatus: "2", // 任务状态
      taskType: "", // 任务类型
      attachments: [],
      lastClickTime: 0,
      clickInterval: 500, // 设置点击间隔时间，单位为毫秒
      startTime: dayjs(), // 开始时间
      page_url: window.location.href, // 页面链接
      page_id: window.location.pathname, // 页面唯一标识
    };
  },
  async created() {
    this.getStatistics();
    this.getTaskList();
    await wxSDK.config(
      ["shareToExternalContact", "shareAppMessage", "thirdPartyOpenPage"],
      ["shareToExternalContact", "shareAppMessage", "thirdPartyOpenPage"]
    );
  },
  mounted() {
    // 埋点 浏览开始
    browseEvent({
      tab_name: "任务", // tab名称
      page_name: "任务列表", // 页面名
      page_url: this.page_url, // 页面链接
      page_id: this.page_id, // 页面唯一标识
      start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
    });
  },
  beforeDestroy() {
    // 埋点 浏览结束
    browseEvent({
      tab_name: "任务", // tab名称
      page_name: "任务列表", // 页面名
      page_url: this.page_url, // 页面链接
      page_id: this.page_id, // 页面唯一标识
      end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
      view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
    });
  },
  methods: {
    // 格式化时间
    formatTime(finishTime) {
      return dayjs(finishTime).format("YYYY-MM-DD HH:mm");
    },
    // 判断文件大小
    isFileSize(fileSizeKB, limitMB) {
      // 将 MB 转换为 KB 进行比较
      const limitKB = limitMB * 1024;
      return fileSizeKB > limitKB;
    },
    // 获取任务统计
    async getStatistics() {
      const res = await statisticsApi({
        tenantId: 120000,
        userId: this.userInfo.userId,
      });
      if (res.code === 0) {
        this.taskTotal = res.data;
      }
    },
    // 打开筛选 popup
    onOpenFilter() {
      this.showOverlay = !this.showOverlay;
    },
    // 获取任务列表
    async getTaskList() {
      const res = await taskListApi({
        userId: this.userInfo.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        taskStatus: this.taskStatus,
        taskType: this.taskType,
      });
      if (res.code === 0) {
        const dataListPromises = res.data.dataList.map(async (item) => {
          if (item.additionalInfo) {
            // 获取素材信息
            const materialList = await this.getshareInfo(item.additionalInfo);
            return {
              ...item,
              materialList,
            };
          } else {
            return item;
          }
        });
        const dataList = await Promise.all(dataListPromises);
        this.list = this.list.concat(dataList);
        this.baseList = this.list;
        this.loading = false;

        if (res.data.dataList.length < 10) {
          this.finished = true;
        }
      }
    },
    // 加载list
    onLoad() {
      this.pageIndex++;
      this.getTaskList();
    },
    // 切换tabs前置，防止快速点击
    beforeChangeTabs() {
      const now = Date.now();
      // 如果距离上次点击时间小于设定的间隔，则忽略此次点击
      if (now - this.lastClickTime < this.clickInterval) {
        return;
      } else {
        this.lastClickTime = now;
        return true;
      }
    },
    // 切换tabs
    handleTabClick() {
      this.finished = false;
      this.pageIndex = 1;
      this.list = [];
      this.taskType = "";
      this.getTaskList();
    },
    // 切换任务类型
    checkType(val) {
      this.taskType = val;
      if (val) {
        this.list = this.baseList.filter((item) => item.taskType === val);
      } else {
        this.list = this.baseList;
      }
    },
    // 完成任务
    async handleTask(item) {
      const res = await finishTaskApi({
        taskId: item.id,
        tenantId: 120000,
        isFeedback: item.isFeedback,
      });
      if (res.code === 0) {
        // 埋点 任务完成
        pageClickEvent({
          button_name: "完成", // 按钮名称
          activity_id: item.id, // 任务ID
          activity_name: item.taskName, // 任务名称
          activity_type: item.taskTypeDesc, // 任务类型
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "任务", // 页面名
          tab_name: "任务", // tab名称
        });
        Toast.success("操作成功");
        this.pageIndex = 1;
        this.list = [];
        this.getStatistics();
        this.getTaskList();
      }
    },
    // 进入详情页
    goDetails(item, type) {
      if (type === 1) {
        // 埋点 任务查看
        pageClickEvent({
          button_name: "任务查看", // 按钮名称
          activity_id: item.id, // 任务ID
          activity_name: item.taskName, // 任务名称
          activity_type: item.taskTypeDesc, // 任务类型
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "任务", // 页面名
          tab_name: "任务", // tab名称
        });
      }
      sessionStorage.setItem("taskInfo", JSON.stringify(item));
      sessionStorage.setItem("taskType", type);
      this.$router.push({
        name: `taskDetails`,
        params: {
          tenant: 120000,
        },
      });
    },
    // 获取素材信息
    async getshareInfo(ids) {
      const res = await getshareInfoListApi({
        ids: ids,
        key: "",
      });
      if (res.code === 0) {
        const list = res.data.map((item) => {
          if (item.type === 1) {
            return {
              ...item,
              pictures: JSON.parse(item.pictures[0]),
            };
          } else if (item.type === 2) {
            return {
              ...item,
              videos: JSON.parse(item.videos[0]),
            };
          } else if (item.type === 3) {
            return item;
          } else if (item.type === 4) {
            return {
              ...item,
              attachment: JSON.parse(item.attachment[0]),
            };
          }
        });
        return list;
      }
    },
    // 转发
    async forwardFn(data) {
      let sourceIds = "";
      Toast.loading({
        duration: 0,
        message: "转发中...",
        forbidClick: true,
      });
      // 定义文件类型图标映射
      const iconMap = {
        png:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_img.png",
        jpg:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_img.png",
        mp4:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_video.png",
        xlsx:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_excel.png",
        xls:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_excel.png",
        docx:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_word.png",
        doc:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_word.png",
        zip:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_zip.png",
        ppt:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_ppt.png",
        pptx:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_ppt.png",
        pdf:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_pdf.png",
        mp3:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_mp3.png",
        amr:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_mp3.png",
        txt:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_txt.png",
        psd:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_psd.png",
        lj:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_lj.png",
      };
      try {
        await Promise.all(
          data.materialList.map(async (item) => {
            sourceIds += `${item.id},`;
            if (item.type === 1) {
              // 图片
              this.attachments.push({
                msgtype: "image",
                image: {
                  imgUrl: item.cosPath,
                },
              });
            } else if (item.type === 2) {
              // 视频
              if (this.isFileSize(item.videos.size, 10)) {
                // 超出10MB
                this.attachments.push({
                  msgtype: "link",
                  link: {
                    title: item.title,
                    imgUrl: item.videoCoverUrl,
                    url: `${window.location.origin}/s/file?shareKey=${item.shareKey}`,
                  },
                });
              } else {
                // 未超出10MB，上传视频
                const res = await uploadMediaApi({
                  appId: global.APP_CONFIG.appId,
                  cosUrl: item.cosPath,
                  tenantId: 120000,
                  type: "video",
                });

                if (res.code === 0) {
                  this.attachments.push({
                    msgtype: "video",
                    video: {
                      mediaid: res.data.id,
                    },
                  });
                } else {
                  console.error("视频上传失败:", res);
                }
              }
            } else if (item.type === 3) {
              // 图文
              this.attachments.push({
                msgtype: "link",
                link: {
                  title: item.title,
                  imgUrl: item.imgUrl,
                  url: `${window.location.origin}/s/file?shareKey=${
                    item.shareKey
                  }&name=${encodeURIComponent(this.userInfo.name)}&userId=${
                    this.userInfo.userId
                  }`,
                },
              });
            } else if (item.type === 4) {
              // 文件
              const ext = item.attachment.ext;
              const imgUrl = iconMap[ext] || iconMap.lj;
              const maxSize = ext === "mp3" || ext === "amr" ? 2 : 20; // 音频2MB，其他文件20MB
              if (this.isFileSize(item.attachment.size, maxSize)) {
                // 超出大小限制
                this.attachments.push({
                  msgtype: "link",
                  link: {
                    title: item.title,
                    imgUrl: imgUrl,
                    url: `${window.location.origin}/s/file?shareKey=${item.shareKey}`,
                  },
                });
              } else {
                // 未超出大小限制，上传文件
                const res = await uploadMediaApi({
                  appId: global.APP_CONFIG.appId,
                  cosUrl: item.cosPath,
                  tenantId: 120000,
                  type: "file",
                });
                if (res.code === 0) {
                  this.attachments.push({
                    msgtype: "file",
                    file: {
                      mediaid: res.data.id,
                    },
                  });
                } else {
                  console.error("文件上传失败:", res);
                }
              }
            }
          })
        );
        // 所有上传任务完成后，执行分享
        const attachments = JSON.parse(JSON.stringify(this.attachments));
        console.log("准备分享的附件:", attachments);

        Toast.clear();
        // 转发
        wx.invoke(
          "shareToExternalContact",
          {
            text: {
              content: "",
            },
            attachments: attachments,
          },
          async (res) => {
            if (res.err_msg === "shareToExternalContact:ok") {
              if (data.taskStatus === 2) {
                const res = await finishTaskApi({
                  taskId: data.id,
                  tenantId: 120000,
                });

                if (res.code === 0) {
                  // 埋点 转发
                  pageClickEvent({
                    button_name: "转发", // 按钮名称
                    activity_id: data.id, // 任务ID
                    activity_name: data.taskName, // 任务名称
                    activity_type: data.taskTypeDesc, // 任务类型
                    page_id: this.page_id, // 页面唯一标识
                    page_url: this.page_url, // 页面链接
                    page_name: "任务", // 页面名
                    tab_name: "任务", // tab名称
                  });
                  Toast.success("操作成功");
                  await addForwardRecordApi({
                    sourceIds: sourceIds,
                    sourceType: 1,
                    channel: 1,
                  });
                  this.pageIndex = 1;
                  this.list = [];
                  this.getStatistics();
                  this.getTaskList();
                } else {
                  console.error("完成任务失败:", res);
                  Toast.fail("完成任务失败");
                }
              }
            } else {
              console.error("分享失败:", res);
              Toast.fail("分享失败");
            }
          }
        );
      } catch (error) {
        console.error("转发过程中发生错误:", error);
        Toast.clear();
        Toast.fail("转发失败，请重试");
      } finally {
        // 无论成功或失败，最后清空附件列表
        this.attachments = [];
      }
    },
    // 去申请
    goApply(item) {
      wx.invoke(
        "thirdPartyOpenPage",
        {
          oaType: "10001", // 发起审批
          templateId: "94a33bc9adc53fef37094fc27b3485a4_1425761362", // 发起审批的模板 ID
          thirdNo: "202507100005", // 审批单号
          extData: {
            fieldList: [
              {
                title: "采购类型",
                type: "text",
                value: "市场活动",
              },
              {
                title: "采购说明",
                type: "text",
                value: "购买个人办公电脑",
              },
              {
                title: "采购金额",
                type: "text",
                value: "4839.00元",
              },
              {
                title: "申请时间",
                type: "text",
                value: "2018/06/20",
              },
              {
                title: "订单链接",
                type: "link", // link类型，用于在审批详情页展示第三方订单跳转地址
                value: "https://www.qq.com",
              },
            ],
          },
        },
        function(res) {
          // 输出接口的回调信息
          console.log(res);
        }
      );
    },
    // 打开任务附件链接
    goAttachment(item) {
      window.open(item.taskLinkUrl);
    },
  },
};
</script>

<style lang="less" scoped>
.task-wrap {
  width: 100%;
  height: 100vh;
  ::v-deep .van-tabs {
    .van-tabs__wrap {
      height: 40px;
      .van-tabs__nav {
        z-index: 9;
        .van-tab {
          .van-tab__text {
            font-size: 15px;
          }
        }
        .tab-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          .icon-filter {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
  .task-type {
    position: fixed;
    top: 40px;
    left: 0;
    background-color: #fff;
    z-index: 9;
    .popup-title {
      font-weight: 500;
      font-size: 14px;
      color: #666666;
      line-height: 18px;
      margin-bottom: 10px;
      padding: 12px 15px 0;
    }
    .param-list {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 44px;
      padding: 0 15px 12px;
      .p-item {
        height: 26px;
        border-radius: 4px;
        border: 1px solid #f2f2f2;
        font-size: 12px;
        color: #666666;
        line-height: 28px;
        margin-right: 10px;
        margin-bottom: 8px;
        padding: 0 15px;
        cursor: pointer;
      }
      .act {
        border: 1px solid #4d4d4d;
        color: #333333;
      }
    }
  }
  .task-list {
    height: calc(100% - 55px);
    padding: 10px 12px;
    overflow-y: auto;
    .task-cell {
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #f2f2f2;
      margin-bottom: 10px;
      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 500;
        font-size: 15px;
        color: #333333;
        margin-bottom: 8px;

        .h-txt {
          font-size: 12px;
          color: #999999;
        }
      }
      .cont {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-bottom: 12px;
        .c-txt {
          margin-bottom: 8px;
        }
        .source-material {
          display: flex;
          flex-direction: column;
          width: 100%;
          .material-item {
            display: flex;
            align-items: center;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #f5f5f5;
            box-sizing: border-box;
            padding: 8px 12px;
            margin-bottom: 6px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          img {
            width: 32px;
            height: 32px;
            margin-right: 8px;
          }
        }
        .attachment {
          color: #458ce3;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #999999;
        .f-left {
          display: flex;
          align-items: center;

          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
        .footer-btn {
          height: 25px;
          border-radius: 4px;
          border: 1px solid #f26147;
          padding: 0 15px;
          line-height: 26px;
          color: #f26147;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
